$(function(){
  $(document).on('click', '.new-products-card-plus, .new-products-card-qty-toggle', function(){
    let val = $(this).parent().find(".new-products-card-input").val();
    let newVal = parseInt(val) + 1;
    $(this).parent().find(".new-products-card-input").val(newVal);
    $(this).parent().find(".new-products-card-qty-slider").attr("style", `transform: translateY(-${newVal * 100}%)`);
    if(newVal > 0){
      $(this).parents(".new-products-card-qty-wrapper").addClass("active");
      $(this).parents(".new-products-card-item").addClass("active");
    }
    let arr = [];
    if($(this).parents(".new-products-card-item").attr("data-selling-plan") == "none"){
      arr.push({ 'id': $(this).parents(".new-products-card-item").attr("data-id"), 'quantity': 1 });
    }
    else{
      arr.push({ 'id': $(this).parents(".new-products-card-item").attr("data-id"), 'selling_plan': $(this).parents(".new-products-card-item").attr("data-selling-plan"), 'quantity': 1 });
    }
    UpdateProdSellingPlan(arr, $(this));
    updateBar();
  });
  $(document).on('click', '.new-products-card-minus', function(){
    let val = $(this).parent().find(".new-products-card-input").val();
    if(parseInt(val) >= 1){
      let newVal = parseInt(val) - 1;
      $(this).parent().find(".new-products-card-input").val(newVal);
      $(this).parent().find(".new-products-card-qty-slider").attr("style", `transform: translateY(-${newVal * 100}%)`);
      if(newVal <= 0){
        $(this).parents(".new-products-card-qty-wrapper").removeClass("active");
        $(this).parents(".new-products-card-item").removeClass("active");
      }
      UpdateProd($(this).parents(".new-products-card-item").attr("data-id"), newVal, $(this));
      updateBar();
    }
  });
  updateBar();
})




function updateBar(){
  if($(".new-products-card-item.active").length > 0){
    if($(".new-products-tier-wrapper").length > 0){
      let max = $(".new-products-tier-wrapper").attr("data-max");
      let total = 0;
      if($(".new-products-card-item.active").length > 0){
        $(".new-products-tier-step").removeClass("active");
        $(".new-products-card-item.active").each(function(){
          let qty = parseInt($(this).find(".new-products-card-input").val());
          let price = parseFloat($(this).find(".new-products-card-price").attr("data-price"));
          total += qty * price;
        });
        $(".new-products-tier-step").each(function(){
          let threshold = parseFloat($(this).attr("data-threshold"));
          if(total >= threshold){
            $(this).addClass("active");
          }
        });
      }
    }
  }
}

$(document).on("click", ".new-products-card-view", function(){
  document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
})

function UpdateProdSellingPlan(productsArr, $this){
  $this.parents(".new-products-card-qty-wrapper").addClass("adding");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.parents(".new-products-card-qty-wrapper").removeClass("adding");
  });
}

function UpdateProd(vid, qty, $this){
  $this.parents(".new-products-card-qty-wrapper").addClass("adding");
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify({
      id: vid,
      quantity: qty,
      sections: "cart-drawer,cart-icon-bubble"
    })
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.parents(".new-products-card-qty-wrapper").removeClass("adding");
  });
}